export default {
  stockCheck: {
    productBatch: '批次号',
    originalQuantity: '系统库存',
    checkQuantity: '盘点库存',
    checkFlag: '盘点结果',
    productTime: '生产日期',
    checkTime: '盘点时间',
    beforeCheckAmount: '盘前金额',
    afterCheckAmount: '盘后金额',
    checkPerson: '盘点人',
    viewRecord: '查看记录',
    checkAdd: '新增盘点'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/ims/stockCheck.js